// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1tWJY","colMin":"styles_colMin__260Wu","colCheckbox":"styles_colCheckbox__MKuja"};